import { createReducer, on } from '@ngrx/store';
import { setAxisExtremes } from './axis-extremes.action';
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
export const axisExtremes = createReducer({}, on(setAxisExtremes, (state, action) => {
    return action.axisExtremes;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.axisExtremes;
}));
